const {h, render, Component} = require('preact');
const SearchView = require('../../views/search/search')

class Search extends Component {
  constructor(props) {
    super(props);
    this.getTextAndSearch = this.getTextAndSearch.bind(this);
    this.handleChangeInSearchInput = this.handleChangeInSearchInput.bind(this);
    this.focusOnSearchInput = this.focusOnSearchInput.bind(this);
    this.searchInputText = document.getElementsByClassName("search-input-text")
  }

  focusOnSearchInput(){
    if (this.searchInputText && this.searchInputText.length > 0)
      this.searchInputText[0].focus();
  }

  getTextAndSearch(){
    if (this.searchInputText && this.searchInputText.length > 0){
      let searchText = this.searchInputText[0].value;
      if (searchText && searchText.trim().length > 0){
        // handleSearch property will be coming from parent component
        this.searchText = searchText.trim()
        this.searchInputText[0].blur();
        this.props.handleSearch(searchText.trim())
      }
      else{
        this.focusOnSearchInput();
      }
    }
    return null;
  }

  handleChangeInSearchInput(event){
    if(event.key == 'Enter'){
      this.getTextAndSearch();
    }
  }

  render() {
    return (
        <SearchView
          getTextAndSearch={this.getTextAndSearch.bind(this)}
          handleChangeInSearchInput={this.handleChangeInSearchInput.bind(this)}
          focusOnSearchInput={this.focusOnSearchInput.bind(this)}
          searchText={this.props.searchText}
         />
    )
  }
}

module.exports = Search
